const unidentifiedCloak = `

#### How to Identify Your Cloak
- Use a **Soulstone Teardrop** or **Soulstone Teardrop (Enhanced)** to transfer the effect of the soulstone to the item.

#### Upgrade Process
- Open the **Upgrade Window**.
- Place the **Unidentified Deco Cloak** in the **Main Slot**.
- Place a **Soulstone** in the **Next Slot**.

#### Important Notes
- Once identified with a **Soulstone**, the effect **cannot be undone**.
- There is **no change function** available yet.

Enjoy upgrading your cloak!`;

export default unidentifiedCloak;
